import { useCallback } from "react";

import { connect } from "react-redux";
import { Formik } from "formik";
import {
  Button,
  FormGroup,
  Label,
  Input,
  Form,
  FormFeedback,
  Container,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";

import { login } from "./actions";
import { LoginWithGoogle } from "@/modules/Login/components/LoginWithGoogle";

const validate = (values) => {
  const errors = {};
  if (!values.email) errors.email = "Required";
  if (!values.password) errors.password = "Required";
  return errors;
};

const Login = ({ login }) => {
  const submit = useCallback((values) => login(values), [login]);

  return (
    <Container>
      <Row>
        <Col xs="12" md="6" lg="4" className="mx-auto">
          <Card>
            <CardBody className="text-center display-flex align-items-center">
              <h1 className="title">NR Admin Portal</h1>
              <p className="subtitle">Login</p>
              <LoginWithGoogle/>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (_state) => {
  return {};
};
export default connect(mapStateToProps, {
  login,
})(Login);
